<!-- StoreInfo.vue -->
<template>
  <section class="store-info">
    <div class="header">
      <h1 class="shop">{{ store.name }}</h1>

      <div class="addr-line">
        <span class="addr">{{ store.address }}</span>
      </div>

      <!-- 전화번호 라인 -->
      <div v-if="store.tel" class="phone-line">
        <!-- 아이콘 -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor" aria-hidden="true"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z"/></svg>
        <span class="sr-only">전화번호</span>
        <a class="tel" :href="`tel:${store.tel}`">{{ store.tel }}</a>
      </div>


      <div class="biz">
        <div v-if="store.ceo">대표자명: {{ store.ceo }}</div>
        <div v-if="store.idnum">사업자등록번호: {{ store.idnum }}</div>
        <div v-if="store.corpname">상호명: {{ store.corpname }}</div>
      </div>
    </div>

    <div class="block">
      <h2 class="block-title">{{ $t('ops_info') }}</h2>
      <div v-if="exists_open_status" class="hours">
        <div v-for="(item, i) in open_status_arr" :key="i" class="row">
          <div v-if="open_status[item]">
            <span class="day">{{ $t(item) }}</span>
            <span class="span">{{ time2(open_status[item]["open"]) }} ~ {{ time2(open_status[item]["close"]) }}
                  <div v-if="open_status[item]['break']">
                    ({{ $t('break_time') }} : {{ time2(open_status[item]['break']['start']) }} ~ {{ time2(open_status[item]['break']['end']) }})
                  </div></span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="store.notice" class="block">
      <h2 class="block-title">공지사항</h2>
      <p class="text pre">{{ store.notice }}</p>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'StoreInfo',
  props: {
    store: { type: Object, required: true }
  },
  mounted() {
    this.parse_ops_info()
  },
  data: () => ({
    open_status_arr:['mon','tue','wed','thu','fri','sat','sun'],
    exists_open_status:false,
    open_status:null,
  }),
  methods: {
    parse_ops_info() {
      let v = this.store.hours
      //console.log(v)
      this.open_status = v
      if(v)
        this.exists_open_status = true
      else
        this.exists_open_status = false
    },
    time2:function(time) {
      let [hour, minute] = time.split(":").map(Number);
      let label = "";
      let nextDay = false;

      if (hour >= 24) {
        hour -= 24;
        nextDay = true;
      }

      if (hour === 0) {
        label = this.$t('morning')+" 12";
      } else if (hour < 6) {
        label = this.$t('morning') + ` ${hour}`;
      } else if (hour < 12) {
        label = this.$t('morning') + ` ${hour}`;
      } else if (hour === 12) {
        label = this.$t('noon') + ` 12`;
      } else {
        label = this.$t('noon') + ` ${hour - 12}`;
      }

      return `${nextDay ? this.$t('nextday') + " " : ""}${label}:${minute.toString().padStart(2, "0")}`;
    },
  },
}
</script>


<style scoped>
.store-info { padding: 16px 20px; line-height: 1.6; color: #222; }
.header { margin-bottom: 12px; }
.shop { margin: 0 0 6px; font-size: 20px; font-weight: 800; }
.addr-line, .phone-line { display: flex; gap: 10px; align-items: baseline; flex-wrap: wrap; margin-bottom: 6px; }
.addr { color: #222; }
.phone-line { display:flex; gap:10px; align-items:center; margin:6px 0; }
.icon-phone { width:18px; height:18px; color:#4a4f57; fill:currentColor; flex:0 0 auto; }
/* 스크린리더 전용 텍스트 */
.sr-only{
  position:absolute; width:1px; height:1px; padding:0; margin:-1px;
  overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0;
}
.tel { color: #222; text-decoration: none; }
.biz { color: #60646c; font-size: 14px; margin-top: 6px; }
.block { margin: 18px 0; }
.block-title { font-size: 16px; font-weight: 800; margin: 0 0 6px; color: #2a2f38; }
.text { color: #2a2f38; }
.pre { white-space: pre-line; }
/* 기존 */
.hours .row { display: flex; gap: 12px; padding: 2px 0; }

/* ✨추가: 내부 래퍼를 플렉스로 만들어 day/시간 사이 간격 적용 */
.hours .row > div {
  display: flex;
  align-items: baseline;
  column-gap: 10px;   /* 요일과 시간 사이 간격 */
}

/* 요일 칼럼 고정폭 + 정렬 */
.hours .day {
  flex: 0 0 56px;     /* 고정폭(원하면 64px 등으로 조정) */
  color: #4a4f57;
}

/* 시간 영역은 남은 공간 사용 */
.hours .span {
  flex: 1 1 auto;
  color: #222;
}

/* 끊어 읽기 좋은 휴게시간 줄바꿈/여백 */
.hours .span > div {
  display: block;
  margin-top: 2px;
  color: #666;
  font-size: 0.92em;
}
.hours .day { width: 56px; color: #4a4f57; }
.hours .span { color: #222; }
.support-link { display: inline-block; margin-top: 10px; text-decoration: none; color: #2a79ff; font-weight: 700; }
</style>
